import ReactGA from "react-ga4";

/**
 * GA4 커스텀 이벤트를 전송하는 함수
 * @param {string} action - 이벤트 액션 (예: 'click', 'view', 'share')
 * @param {string} category - 이벤트 카테고리 (예: 'button', 'prayer', 'result')
 * @param {string} label - 이벤트 라벨 (선택사항)
 * @param {number} value - 이벤트 값 (선택사항)
 */
export const trackEvent = (action, category, label = null, value = null) => {
  if (process.env.REACT_APP_GA_KEY) {
    const eventData = {
      action,
      category,
    };

    if (label) eventData.label = label;
    if (value) eventData.value = value;

    ReactGA.event(action, eventData);
  }
};

/**
 * 기도제목 시작 이벤트 추적
 */
export const trackPrayerStart = () => {
  trackEvent("start_prayer", "prayer", "main_page");
};

/**
 * 기도제목 결과 보기 이벤트 추적
 * @param {string} prayerType - 기도제목 타입
 */
export const trackPrayerResult = (prayerType) => {
  trackEvent("view_prayer_result", "prayer", prayerType);
};

/**
 * 기도제목 공유 이벤트 추적
 * @param {string} shareMethod - 공유 방법 ('kakao', 'download', 'link')
 * @param {string} prayerType - 기도제목 타입
 */
export const trackPrayerShare = (shareMethod, prayerType = null) => {
  trackEvent("share_prayer", "share", shareMethod, prayerType);
};

/**
 * 다시하기 이벤트 추적
 */
export const trackPrayerRetry = () => {
  trackEvent("retry_prayer", "prayer", "result_page");
};

/**
 * 로딩 페이지 완료 이벤트 추적
 */
export const trackLoadingComplete = () => {
  trackEvent("loading_complete", "loading", "animation_finished");
};
